import { CompanyStaffState } from './_states/company-staff.state';
import { CompanyProfileState } from './_states/company-profile.state';

export const companyStaffState = [CompanyStaffState, CompanyProfileState];
